import React from 'react';
import { Shield, CheckCircle } from '@phosphor-icons/react';
import { Card } from './ui/card';

const WARRANTIES = [
  {
    days: 3,
    label: '3 días',
    price: 'Gratis',
    priceValue: 0,
    description: 'Cobertura básica incluida',
    highlight: false,
    color: 'from-muted to-muted',
  },
  {
    days: 30,
    label: '30 días',
    price: '$2.000',
    originalPrice: '$3.500',
    discountPct: 43,
    priceValue: 2000,
    description: 'Cobertura extendida — todo el mes',
    highlight: true,
    color: 'from-[#00E676] to-emerald-600',
  },
  {
    days: 60,
    label: '60 días',
    price: '$5.100',
    originalPrice: '$8.000',
    discountPct: 36,
    priceValue: 5100,
    description: 'Doble mes de protección total',
    highlight: false,
    color: 'from-[#0066FF] to-[#0084FF]',
  },
  {
    days: 365,
    label: '1 año',
    price: '$14.500',
    originalPrice: '$22.000',
    discountPct: 34,
    priceValue: 14500,
    description: 'Garantía anual — máxima tranquilidad',
    highlight: false,
    color: 'from-purple-500 to-pink-500',
  },
];

export const WarrantySection = ({ selected = 3, onSelect, showHeader = true, compact = false }) => {
  return (
    <div className={compact ? '' : 'space-y-4'}>
      {showHeader && (
        <div className="text-center mb-6">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-[#00E676]/10 border border-[#00E676]/30 mb-3">
            <Shield size={16} weight="fill" className="text-[#00E676]" />
            <span className="text-xs font-bold tracking-widest text-[#00E676] uppercase">
              Garantía de recarga
            </span>
          </div>
          <h3 className="text-xl sm:text-2xl font-semibold mb-2">
            Tu pedido siempre protegido
          </h3>
          <p className="text-sm text-muted-foreground max-w-xl mx-auto">
            Si tu pedido sufre alguna baja en el período de garantía, lo recargamos sin costo.
            Cubrimos cualquier eventualidad para que solo te enfoques en crecer.
          </p>
        </div>
      )}

      <div className={`grid grid-cols-2 ${compact ? 'lg:grid-cols-4 gap-3' : 'md:grid-cols-4 gap-3'}`}>
        {WARRANTIES.map((w) => {
          const isSelected = selected === w.days;
          return (
            <button
              type="button"
              key={w.days}
              onClick={() => onSelect && onSelect(w.days)}
              className={`relative text-left rounded-xl border-2 p-4 pt-5 transition-all duration-200 ${
                isSelected
                  ? 'border-[#00E676] bg-[#00E676]/5 ring-2 ring-[#00E676]/30'
                  : 'border-border hover:border-[#00E676]/50 hover:bg-muted/50'
              }`}
              data-testid={`warranty-${w.days}`}
            >
              {w.highlight && !isSelected && (
                <div className="absolute -top-2.5 left-3 px-2 py-0.5 rounded-full bg-[#0066FF] text-white text-[9px] font-bold tracking-wider uppercase shadow-md">
                  Recomendado
                </div>
              )}
              {w.discountPct && (
                <div className="absolute -top-2.5 right-3 px-2 py-0.5 rounded-full bg-gradient-to-r from-red-500 to-orange-500 text-white text-[9px] font-bold tracking-wider uppercase shadow-md animate-pulse">
                  -{w.discountPct}% OFF
                </div>
              )}
              <div className="flex items-start justify-between mb-2">
                <div>
                  <div className="text-[10px] text-muted-foreground uppercase tracking-wider mb-1">
                    Garantía
                  </div>
                  <div className="text-lg font-bold">{w.label}</div>
                </div>
                {isSelected && <CheckCircle size={18} weight="fill" className="text-[#00E676]" />}
              </div>
              {w.originalPrice && (
                <div className="text-[11px] text-muted-foreground line-through leading-none mb-0.5">
                  Antes {w.originalPrice}
                </div>
              )}
              <div
                className={`text-lg font-bold leading-tight ${
                  w.priceValue === 0 ? 'text-[#00E676]' : 'text-foreground'
                }`}
              >
                {w.price}
              </div>
              <p className="text-[11px] text-muted-foreground mt-1.5 leading-snug">{w.description}</p>
            </button>
          );
        })}
      </div>

      {!compact && (
        <p className="text-xs text-muted-foreground text-center mt-4">
          ⚠️ <strong>Política de reembolsos:</strong> solo procesamos reembolsos si el pedido no llega
          a entregarse. En todos los demás casos, la garantía cubre recargas.
        </p>
      )}
    </div>
  );
};
